
import React, { Component } from 'react'
import { injectIntl } from 'react-intl'
import Select from 'react-select'
import Integrations from './Integrations.jsx'
import GlobalHelper from "../common/GlobalHelper";

class IntegrationSelect extends Component {

    constructor(props, context) {
        super(props, context)
        this.state = {
            options: [],
            multi: props.multi || false,
            selectedOptions: this.props.value || []
        }

        const defaultCallback = () => { }
        this.name = this.props.name
        this.placeholder = this.props.placeholder
        this.onChange = this.props.onChange || defaultCallback
        this.handleChange = this.handleChange.bind(this)
    }

    componentDidMount() {
        let optionsAux = Integrations.getAvailableFilters()

        if (GlobalHelper.isSuperUserLoggedIn() && this.props.supportedFeature) {
            Integrations.getAvailableSuperUserFiltersWithSupportedFeature(this.props.supportedFeature).forEach(elem => {
                if (optionsAux.length === 0) {
                    this.onChange(elem.value, elem.label, elem.metadata)
                }
                optionsAux.push(elem)
            })
        }

        this.setState({ options: optionsAux })
    }

    handleChange(selectedOption) {
        this.setState({
            selectedOptions: selectedOption
        }, () => {
            if (selectedOption) {
                if (this.state.multi === true) {
                    this.onChange(selectedOption.map(option => { return option.value }), selectedOption.map(option => { return option.label }).join(','))
                } else {
                    this.onChange(selectedOption.value, selectedOption.label, selectedOption.metadata)
                }
            } else {
                this.onChange("", "", "")
            }
        });
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.value !== this.state.selectedOptions) {
            this.setState({
                selectedOptions: nextProps.value || []
            })
        }
    }

    render() {
        return (
            <Select
                name={this.name}
                searchable={false}
                multi={this.state.multi}
                placeholder={this.placeholder}
                value={this.state.selectedOptions}
                onChange={this.handleChange}
                options={this.state.options}
            />
        )
    }
}

export default injectIntl(IntegrationSelect)





// WEBPACK FOOTER //
// ./src/integration/integrationSelect.component.jsx